import { Outlet, RouteObject, useLocation, useParams } from 'react-router-dom'
import ManageQueue from '../pages/queue-configuration/ManageQueues'
import CreateQueue from '../pages/queue-configuration/CreateQueue'
import TenantIdBreadcrumb from '../components/common/TenantIdBreadCrumb'
import ManageQueueConfig from '../pages/queue-configuration/ManageQueueConfig.page'
import ManageQueueLayoutConfig from '../pages/queue-configuration/ManageQueueLayoutConfig.page'
import QueueBreadCrumb from '../components/common/QueueBreadCrumb'
import DynamicQueues from '../pages/queue-configuration/DynamicQueues'
import IntakeQueReview from '../pages/intake-ques/IntakeQueReview'
import { INTAKE_QUEUE_TABS } from '../utils/constants'
import { AddEditRecordWarpperCallForCase } from '../pages/AddEditViewRecord.page'
import EntityIdBreadcrumb from '../components/common/EntityIdBreadCrumb'
import { DynamicQueuesProps } from '../types/queueConfig.types'
import PopoutWindow from '../pages/intake-ques/popout-window/PopoutWindow'
import { useAppSelector } from '../utils/agent.store'
import { ReadOnlyProtectedRoute } from '../guards/readonly.guard'
import IntakeDocumentReview from '../pages/intake-ques/IntakeDocumentReview'

const DynamicQueuesWrapper = (props: DynamicQueuesProps) => {
  const { entityid, layoutid, id } = useParams()
  const tenantid = useAppSelector(
    (state) => state?.authUser?.selectedClientTenant?.id
  )
  localStorage.setItem(
    'workflowNavObject',
    JSON.stringify({
      [tenantid?.toString() ?? '']: {
        entityId: entityid ?? '',
        layoutId: layoutid ?? '',
        Id: id ?? '',
      },
    })
  )
  return (
    <DynamicQueues
      {...props}
      key={`${tenantid}-${entityid}-${layoutid}-${id}`}
    />
  )
}

const ConditionalBreadcrumb = () => {
  const location = useLocation()
  const isDynamicQueue = location.pathname.includes('dynamic-queue')

  return (
    <TenantIdBreadcrumb
      left={isDynamicQueue ? 'Queues - ' : 'Manage Queue - '}
    />
  )
}

const QueueConfigRouter: RouteObject = {
  path: 'manage-queue',
  element: <ManageQueueConfig />,
  handle: {
    crumb: () => <ConditionalBreadcrumb />,
  },
  children: [
    {
      path: '',
      element: (
        <ReadOnlyProtectedRoute>
          <ManageQueue />
        </ReadOnlyProtectedRoute>
      ),
    },
    {
      path: ':tenantid',
      element: (
        <ReadOnlyProtectedRoute>
          <ManageQueueLayoutConfig />
        </ReadOnlyProtectedRoute>
      ),
      children: [
        {
          path: 'create-queue',
          element: <CreateQueue />,
          handle: {
            crumb: () => 'Create Queue',
          },
        },
        {
          path: 'edit-queue/:id',
          element: <CreateQueue />,
          handle: {
            crumb: () => <QueueBreadCrumb right={` - edit`} />,
          },
        },
        {
          path: 'view-queue/:id',
          element: <CreateQueue />,
          handle: {
            crumb: () => <QueueBreadCrumb right={` - view`} />,
          },
        },
      ],
    },
    {
      path: 'dynamic-queue/:entityid/:layoutid/:id',
      element: <Outlet />,

      children: [
        {
          path: '',
          element: <Outlet />,
          handle: {
            crumb: () => <QueueBreadCrumb />,
          },
          children: [
            {
              path: '',
              element: (
                <DynamicQueuesWrapper uniqueKey={INTAKE_QUEUE_TABS?.fax?.key} />
              ),
            },
            {
              path: ':communicationId/:caseEntityId',
              element: (
                <IntakeQueReview name={'Fax'} entityName="communication" />
              ),
              handle: {
                crumb: () => 'Review',
              },
            },
            {
              path: ':communicationId/:caseEntityId/popup/:index',
              element: <PopoutWindow name={'Fax'} />,
            },
            {
              path: ':communicationId/:caseEntityId/hcp',
              element: (
                <IntakeQueReview
                  name={INTAKE_QUEUE_TABS.web.key}
                  entityName="hcp_portal_entity"
                />
              ),
              handle: {
                crumb: () => 'Review',
              },
            },
            {
              path: ':communicationId/:caseEntityId/hcp/popup/:index',
              element: (
                <PopoutWindow
                  name={INTAKE_QUEUE_TABS.web.key}
                  entityName="hcp_portal_entity"
                />
              ),
            },
            {
              path: 'view/:caseid',
              element: <AddEditRecordWarpperCallForCase mode={'view'} />,
              handle: {
                crumb: () => <EntityIdBreadcrumb right={' / View'} />,
              },
            },
            {
              path: `edit/:caseid`,
              element: <AddEditRecordWarpperCallForCase mode={'edit'} />,
              handle: {
                crumb: () => <EntityIdBreadcrumb right={' / Edit'} />,
              },
            },
          ],
        },
        {
          //TODO: change later, currently seems wrong
          path: '',
          element: (
            <DynamicQueuesWrapper uniqueKey={INTAKE_QUEUE_TABS.web.key} />
          ),
        },

        // {
        //   path: '',
        //   element: <DynamicQueuesWrapper uniqueKey={INTAKE_QUEUE_TABS.email.key} />,
        // },
      ],
    },
    {
      path: 'dynamic-queue/:entityId',
      element: <Outlet />,
      children: [
        {
          path: '',
          element: <DynamicQueuesWrapper uniqueKey="fax" />,
          handle: {
            crumb: () => 'Document',
          },
        },
        {
          path: ':documentId',
          element: <IntakeDocumentReview />,
          handle: {
            crumb: () => 'Review',
          },
        },
        {
          path: ':documentId/case/:caseId',
          element: <IntakeDocumentReview />,
          handle: {
            crumb: () => 'Review',
          },
        },
        {
          path: ':documentId/popup/:index',
          element: <PopoutWindow entityName={'Document'} />,
        },
        {
          path: ':documentId/case/:caseId/popup/:index',
          element: <PopoutWindow entityName={'Document'} />,
        },
      ],
    },
  ],
}

export default QueueConfigRouter
